/*
 * "Styled Your Way" shoppable strip.
 *
 * Two independent behaviours live here:
 *  1. Hotspot popovers — one open at a time, closed by outside click, another
 *     hotspot, or Escape. Each is flipped to stay inside its own photo rather
 *     than spilling into the next one in the strip.
 *  2. The prev/next arrows page the track by roughly one viewport, and
 *     disable themselves at either end so they never look clickable when
 *     they'd do nothing.
 */
(function () {
  'use strict';

  var sections = document.querySelectorAll('.rumi-hotspots');
  if (!sections.length) return;

  function closeCard(hotspot) {
    var toggle = hotspot.querySelector('[data-rumi-hotspot-toggle]');
    var card = hotspot.querySelector('[data-rumi-hotspot-card]');
    if (!toggle || !card) return;
    toggle.setAttribute('aria-expanded', 'false');
    card.hidden = true;
  }

  function openCard(hotspot, media) {
    var toggle = hotspot.querySelector('[data-rumi-hotspot-toggle]');
    var card = hotspot.querySelector('[data-rumi-hotspot-card]');
    if (!toggle || !card) return;

    toggle.setAttribute('aria-expanded', 'true');
    card.hidden = false;

    // Reset flip classes before measuring, then pin the card back inside the
    // photo on whichever edges it would otherwise cross.
    hotspot.classList.remove('rumi-hotspot--flip-down', 'rumi-hotspot--align-start', 'rumi-hotspot--align-end');

    var mediaBox = media.getBoundingClientRect();
    var cardBox = card.getBoundingClientRect();

    if (cardBox.top < mediaBox.top) {
      hotspot.classList.add('rumi-hotspot--flip-down');
      cardBox = card.getBoundingClientRect();
    }

    if (cardBox.left < mediaBox.left) {
      hotspot.classList.add('rumi-hotspot--align-start');
    } else if (cardBox.right > mediaBox.right) {
      hotspot.classList.add('rumi-hotspot--align-end');
    }
  }

  sections.forEach(function (section) {
    var hotspots = section.querySelectorAll('.rumi-hotspot');

    function closeAll(except) {
      hotspots.forEach(function (hotspot) {
        if (hotspot !== except) closeCard(hotspot);
      });
    }

    hotspots.forEach(function (hotspot) {
      var toggle = hotspot.querySelector('[data-rumi-hotspot-toggle]');
      var media = hotspot.closest('.rumi-hotspots__media');
      if (!toggle || !media) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        closeAll(hotspot);
        if (isOpen) {
          closeCard(hotspot);
        } else {
          openCard(hotspot, media);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!section.contains(event.target)) closeAll(null);
    });

    section.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });

    // ---------------------------------------------------------------
    // Track paging
    // ---------------------------------------------------------------
    var track = section.querySelector('[data-rumi-hotspots-track]');
    var prevButton = section.querySelector('[data-rumi-hotspots-prev]');
    var nextButton = section.querySelector('[data-rumi-hotspots-next]');
    if (!track || !nextButton) return;

    function page(direction) {
      var item = track.querySelector('[data-rumi-hotspots-item]');
      var step = item ? item.getBoundingClientRect().width + 3 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * step * 2, behavior: 'smooth' });
    }

    nextButton.addEventListener('click', function () {
      page(1);
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        page(-1);
      });
    }

    function updateNav() {
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

      if (prevButton) prevButton.hidden = atStart;
      nextButton.disabled = atEnd;
    }

    updateNav();
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
  });
})();
